export default {"src":"/_next/static/media/moveDown.bd77819c.svg","height":44,"width":44,"blurWidth":0,"blurHeight":0};